function sanitizeString(string) {
	return string.trim();
}

module.exports = sanitizeString